import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'

export const getOtuCount = (state: typeof State) => state[orderSlice.name].otuCount

export const useGetOtuCountSelector: () => number | null = () => {
  return useSelector(getOtuCount)
}
